import { render, staticRenderFns } from "./knocking.vue?vue&type=template&id=f7ed638c&scoped=true"
import script from "./knocking.vue?vue&type=script&lang=js"
export * from "./knocking.vue?vue&type=script&lang=js"
import style0 from "./knocking.vue?vue&type=style&index=0&id=f7ed638c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ed638c",
  null
  
)

export default component.exports